import { computed } from "vue";
import { useUserStore } from "@/store/user";

export const UserRole = Object.freeze({
  FULL_ACCESS: "FULL_ACCESS",
  SIGHT_USER: "SIGHT_USER",
  NO_ACCESS: "NO_ACCESS",
});

const FULL_ACCESS_GROUPS = ["Developer", "SocioDev"];
const SIGHT_USER_GROUP = "SightUser";

export function computeRole(groups) {
  if (FULL_ACCESS_GROUPS.some((group) => groups.includes(group))) return UserRole.FULL_ACCESS;
  if (groups.includes(SIGHT_USER_GROUP)) return UserRole.SIGHT_USER;
  return UserRole.NO_ACCESS;
}

export function useUserRole() {
  const userStore = useUserStore();
  const role = computed(() => computeRole(userStore.groups));

  return {
    role,
    hasAccess: computed(() => role.value !== UserRole.NO_ACCESS),
    isFullAccess: computed(() => role.value === UserRole.FULL_ACCESS),
  };
}
